import { isXLargeSize } from './WindowSizes';

export const HEADER_HEIGHT = '4rem';
export const HEADER_HEIGHT_IN_PX = isXLargeSize() ? 56 : 64;

export const SELECTOR_VIEW_HEIGHT = '3.1875rem';
